import { apiFetch } from '@shared/api';
import type { CitySuggestion, DictItem } from './constants';

export const fetchBanks = () =>
    apiFetch<DictItem[]>('/v1/ipoteka/a432-banks');

export const fetchCompanies = () =>
    apiFetch<DictItem[]>('/v1/ipoteka/a433-companies');

export const fetchPropertyTypes = () =>
    apiFetch<DictItem[]>('/v1/ipoteka/a439-property-type');

export const fetchProductTypes = () =>
    apiFetch<DictItem[]>('/v1/ipoteka/a4310-product-type');

// Подсказки города — через наш прокси GET /v1/dadata/city (доступен гостю):
// токен DaData живёт только на бэке, границы поиска (город … нас. пункт) — там же.
// Ошибку глушим: подсказки — удобство, город можно выбрать повторным вводом.
export async function searchCities(query: string): Promise<CitySuggestion[]> {
    const q = query.trim();
    if (q.length < 2) return [];

    const data = await apiFetch<{ suggestions?: CitySuggestion[] }>(
        `/v1/dadata/city?q=${encodeURIComponent(q)}`,
    ).catch(() => null);
    return data?.suggestions ?? [];
}
